<template>
	<MoleculeDialog
		:is-open="isOpen"
		is-small
		@close="close"
	>
		<div
			class="py-20"
		>
			<LazyOrganismFormAppointment v-if="!appointmentPlanner.hasPlannedAppointment.value && isOpen" />
			<LazyOrganismFormAppointmentConfirmation v-else-if="isOpen" />
		</div>
	</MoleculeDialog>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		isOpen?: boolean;
	}>(),
	{
		isOpen: false,
	},
);

const {
	trackFormAction,
} = useEventTracking();

const appointmentPlanner = useAppointmentPlanner();

const emit = defineEmits(['close']);
const close = () => {
	trackFormAction('appointment', 'close');
	emit('close');
};
</script>
